// ============================================================
// 🆕 INICIO: Recarga por version desactualizada - 2026-08-31
// ============================================================
// Vive en su propio archivo, y no dentro de `main.ts`, porque lo usan tanto el
// arranque como el componente de error: importar `main.ts` desde un componente
// arrastraria el bootstrap de la aplicacion a la cadena de dependencias.
//
// Contexto completo del problema en la cabecera de `main.ts`.
//
// SEGURO ANTI-BUCLE: si la recarga no arregla el problema, volver a recargar
// dejaria la pestana en un ciclo infinito. Se permite UNA sola recarga por
// pestana; `levantarSeguro()` la limpia cuando la aplicacion lleva un rato en
// pie, para que el siguiente despliegue vuelva a estar cubierto.
const MARCA_RECARGA = 'f2rt_recarga_por_version';

/**
 * Recarga la pestana una unica vez.
 *
 * @returns `true` si la recarga se lanzo; `false` si ya se habia gastado el
 *   intento -o si no hay almacenamiento de sesion, porque sin el no hay seguro
 *   posible y es preferible mostrar el error a arriesgar un bucle-.
 */
export function recargarSiEsVersionVieja(): boolean {
  try {
    if (sessionStorage.getItem(MARCA_RECARGA) === '1') return false;
    sessionStorage.setItem(MARCA_RECARGA, '1');
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}

/** La aplicacion lleva un rato en pie: se levanta el seguro. */
export function levantarSeguroTrasArranqueEstable(msEspera = 30000): void {
  setTimeout(() => {
    try {
      sessionStorage.removeItem(MARCA_RECARGA);
    } catch {
      /* sin almacenamiento no hay nada que limpiar */
    }
  }, msEspera);
}
// ============================================================
// 🆕 FIN: Recarga por version desactualizada
// ============================================================
